export const USERS = 'USERS';
export const SELECTED_USER = 'SELECTED_USER';
